import { Col, Row } from "antd";
import { useCallback, useMemo } from "react";
import { IOption } from "../../../../../../../../../types/Option";
import { getFormattedCurrency } from "../../../../../../../../../lib/currencyFormatter";

type StartBalancesProps = {
  data: any;
};

export const StartBalances = ({ data }: StartBalancesProps) => {
  const itemMap: IOption[] = useMemo(
    () => [
      {
        label: "Beginning of Year",
        value: "begOfYearPrincipal",
      },
      {
        label: "",
        value: "begOfYearUnpaidInterest",
      },
      {
        label: "",
        value: "begOfYearUnpaidLateCharges",
      },
      {
        label: "",
        value: "begOfYearImpoundBal",
      },
    ],
    []
  );

  const getValue = useCallback(
    (item: IOption): string => {
      return getFormattedCurrency(data[item.value] || 0);
    },
    [data]
  );

  return (
    <Row className="w-100 totals-row">
      {itemMap.map((item: IOption, i: number) => (
        <Row
          key={i}
          className="total-card mr-4 main total-card-header px-4 py-2"
        >
          <Col span={14} className="d-flex justify-end">
            <p className="my-0 text-sm title">{item.label}</p>
          </Col>
          <Col span={10} className="d-flex justify-end">
            <p
              className="my-0 ml-2 text-md w-500 elipsis"
              title={getValue(item)}
            >
              {getValue(item)}
            </p>
          </Col>
        </Row>
      ))}
    </Row>
  );
};
